// import node module libraries
import React, { Fragment, useEffect, useState } from 'react';
import { Card, Col, Container, Nav, Navbar, Row } from 'react-bootstrap';
import { Link, useLocation, useParams } from 'react-router-dom';
import ProfileBackground from 'assets/images/background/profile-bg.jpg';

// import routes file
// import utility file
import BudgetService from '../../services/BudgetService';
import { Avatar } from '../../../elements/bootstrap/Avatar';

const BudgetProfileLayout = (props) => {
	const location = useLocation();

	const [budget, setBudget] = useState(null);
	const { id } = useParams();

	useEffect(() => {
		Promise.all([BudgetService.getBudget(id)]).then(([budgetData]) => {
			setBudget(budgetData.data);
		});
	}, [id]);

	return (
		<Fragment>
			<section className="pt-5 pb-5">
				<Container>
					{budget && (
						<>
							{/* User info */}
							<Row className="align-items-center">
								<Col xl={12} lg={12} md={12} sm={12}>
									<div
										className="pt-16 rounded-top-md"
										style={{
											background: `url(${ProfileBackground})`,
											backgroundRepeat: 'no-repeat',
											backgroundSize: 'cover'
										}}
									>
										{' '}
									</div>
									<Card className="px-4 pt-2 pb-4 rounded-0 rounded-bottom shadow-sm">
										<div className="d-flex align-items-end justify-content-between  ">
											<div className="d-flex align-items-center"></div>
											<div>
												<Link
													to="/finances/budget"
													className={`btn btn-outline-dark btn-sm mt-3 d-none d-md-block`}
												>
													Retour à la liste des prévisions budgetaires
												</Link>
											</div>
										</div>
									</Card>
								</Col>
							</Row>

							{/* Content */}
							<Row className="mt-0 mt-md-4">
								<Col lg={3} md={4} sm={12}>
									<Navbar
										expand="lg"
										className="navbar navbar-expand-md navbar-light shadow-sm mb-4 mb-lg-0 sidenav"
									>
										<Link
											className="d-xl-none d-lg-none d-md-none text-inherit fw-bold fs-5 float-start py-1"
											to="#"
										>
											Menu
										</Link>
										<Navbar.Toggle
											aria-controls="basic-navbar-nav"
											className="p-0 focus-none border-0"
											label="Responsive Menu"
										>
											<span
												className="navbar-toggler d-md-none icon-shape icon-sm rounded bg-primary p-0 text-white float-end"
												data-bs-toggle="collapse"
												data-bs-target="#sidenav"
												aria-controls="sidenav"
												aria-expanded="false"
												aria-label="Toggle navigation"
											>
												<span className="fa-solid fa-menu"></span>
											</span>
										</Navbar.Toggle>

										<Navbar.Collapse id="basic-navbar-nav">
											<Nav
												className="me-auto flex-column"
												as="ul"
												activeKey="0"
											>
												<Nav.Item className="navbar-header" as="li">
													Prévision budgétaire
												</Nav.Item>
												<Nav.Item as="li">
													<Link
														className={`nav-link ${
															location.pathname ===
															`/finances/budget/${budget?.id}`
																? 'active'
																: ''
														}`}
														to={`/finances/budget/${budget?.id}`}
													>
														<i className="fa-solid fa-gear nav-icon"></i>
														Mettre à jour la prévision
													</Link>
												</Nav.Item>
												<Nav.Item as="li">
													{
														<Link
															className={`nav-link ${
																location.pathname ===
																`/finances/budget/${budget.id}/delete`
																	? 'active'
																	: ''
															}`}
															to={`/finances/budget/${budget.id}/delete`}
														>
															<i className={`fa-solid fa-trash nav-icon`}></i>
															Supprimer le budget
														</Link>
													}
												</Nav.Item>
											</Nav>
										</Navbar.Collapse>
									</Navbar>
								</Col>

								<Col lg={9} md={8} sm={12}>
									{props.children}
								</Col>
							</Row>
						</>
					)}
				</Container>
			</section>
		</Fragment>
	);
};
export default BudgetProfileLayout;
